<template>
  <div>
    <div class="banner">
      <div>
        <div>特色课程</div>
        <div>助力每个孩子的个性化发展</div>
      </div>
    </div>
    <div class="course">
      <div class="course-b">
        <div class="title">探索课程库</div>
        <div class="course-list">
          <div
            v-for="(item, index) in courseTypeList"
            :key="index"
            :class="{ 'course-type-sel': courseTypeCur == index }"
            @click="chooseCourseType(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
        <div
          v-if="
            courseTypeList.length &&
            courseTypeList[courseTypeCur].children.length
          "
          class="course-secondary"
        >
          <div
            v-for="(item, index) in courseTypeList[courseTypeCur].children"
            :key="index"
            :class="{ 'course-secondary-sel': courseTypeSecondaryCur == index }"
            @click="chooseCourseTypeSecondary(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="courseList">
          <div
            v-for="(item, index) in courseList"
            :key="index"
            @click="goDetail(item)"
            class="course-box"
          >
            <img v-if="item.coverUrl" :src="item.coverUrl" />
            <img v-else src="../../../public/gateway/course/defaultImg.png" />
            <div class="box-title">{{ item.courseName }}</div>
          </div>
        </div>
        <div class="pagination">
          <a-pagination
            show-size-changer
            :total="total"
            :show-total="(total) => `共${total}条`"
            :page-size-options="pageSizeOptions"
            :default-current="1"
            v-model="pagination.currentPage"
            :page-size="pagination.pageSize"
            @change="change"
            @showSizeChange="onShowSizeChange"
            class="pagination-pc"
          />
          <a-pagination
            show-size-changer
            :total="total"
            :show-total="(total) => `共${total}条`"
            :page-size-options="pageSizeOptions"
            :default-current="1"
            size="small"
            v-model="pagination.currentPage"
            :page-size="pagination.pageSize"
            @change="change"
            @showSizeChange="onShowSizeChange"
            class="pagination-mobile"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gateway from '../../api/gateway'
export default {
  name: 'course',
  data() {
    return {
      courseTypeList: [],
      courseTypeCur: 0,
      courseTypeSecondaryCur: 0,
      courseList: [],
      total: 0,
      pagination: {
        currentPage: 1,
        pageSize: 12,
      },
      pageSizeOptions: ['12', '24', '36', '48', '60'],
    }
  },
  created() {
    this.getCourseTypeList(0, this.pagination)
  },
  methods: {
    // 获取课程类型列表
    getCourseTypeList(type, params) {
      gateway.getSchoolCourse(params).then((res) => {
        if (type == 0) {
          let courseCateLevel = res.courseCateLevel
          courseCateLevel.forEach((i) => {
            i.children.unshift({
              name: '全部',
              id: -1,
            })
          })
          courseCateLevel.unshift({
            id: -1,
            name: '全部',
            children: [],
          })
          this.courseTypeList = courseCateLevel
        }
        if (type != 2) this.courseTypeSecondaryCur = 0
        this.courseList = res.data.records
        this.pagination.currentPage = res.data.current
        this.pagination.pageSize = res.data.size
        this.total = res.data.total
      })
    },
    chooseCourseType(item, index) {
      this.courseTypeCur = index
      this.pagination.currentPage = 1
      let params = {}
      if (item.id != -1) params.cateFirstId = item.id
      this.getCourseTypeList(1, {
        ...params,
        ...this.pagination,
      })
    },
    chooseCourseTypeSecondary(item, index) {
      this.courseTypeSecondaryCur = index
      this.pagination.currentPage = 1
      let params = {
        cateFirstId: this.courseTypeList[this.courseTypeCur].id,
      }
      if (item.id != -1) params.cateSecondId = item.id
      this.getCourseTypeList(2, {
        ...params,
        ...this.pagination,
      })
    },
    change(e) {
      let params = {
        ...this.pagination,
      }
      params.currentPage = e
      if (this.courseTypeList[this.courseTypeCur].id != -1) {
        params.cateFirstId = this.courseTypeList[this.courseTypeCur].id
        if (
          this.courseTypeList[this.courseTypeCur].children[
            this.courseTypeSecondaryCur
          ].id != -1
        )
          params.cateSecondId =
            this.courseTypeList[this.courseTypeCur].children[
              this.courseTypeSecondaryCur
            ].id
      }
      this.getCourseTypeList(2, params)
    },
    onShowSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize
      this.change(current)
    },
    goDetail(e) {
      this.$router.push({
        name: 'courseDetail',
        query: {
          id: e.id,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';

@media screen and (min-width: 510px) {
  .banner {
    width: 100%;
    height: 360px;
    font-size: 48px;
    color: #ffffff;
    padding: 0 240px;
    background: url('../../../public/gateway/course/bgImg@2x.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
  }

  .course {
    width: 100%;
    padding: 80px 0 40px;
    background-color: #f7f7f7;

    .course-b {
      width: 100%;
      max-width: 1100px;
      @media screen and (min-width: 1441px) {
        max-width: 1500px;
      }
      margin: 0 auto;

      .title {
        width: 100%;
        font-size: 48px;
        color: #151517;
      }

      .course-list {
        width: 100%;
        margin-top: 18px;
        display: flex;
        align-items: center;

        div {
          width: 145px;
          height: 60px;
          font-size: 20px;
          color: #333333;
          background-color: #ffffff;
          border-radius: 30px;
          border: 1px solid #e3e3e3;
          margin-right: 20px;
          cursor: default;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .course-type-sel {
          color: #ffffff;
          background-color: #0091ff;
        }
      }

      .course-secondary {
        width: 100%;
        height: 60px;
        font-size: 18px;
        color: #333333;
        padding: 0 20px;
        background-color: #ffffff;
        border-radius: 10px;
        margin-top: 20px;
        display: flex;
        align-items: center;
        cursor: default;

        text-align: center;
        white-space: nowrap;
        overflow-x: scroll;
        overflow-y: hidden;

        div {
          margin: 0 20px;
          white-space: nowrap;
          display: inline-block;
          cursor: pointer;
        }

        .course-secondary-sel {
          color: #0091ff;
        }
      }

      ::-webkit-scrollbar {
        display: none;
      }

      .courseList {
        width: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .course-box {
          width: 454px;
          height: 332px;
          margin-right: 30px;
          background-color: #ffffff;
          border-radius: 10px;
          margin-top: 40px;
          cursor: pointer;

          img {
            width: 454px;
            height: 254px;
            border-radius: 10px 10px 0 0;
            object-fit: cover;
          }

          .box-title {
            width: 100%;
            font-size: 22px;
            font-weight: 600;
            padding: 24px;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            white-space: nowrap;
          }
        }
      }

      .pagination {
        width: 100%;
        text-align: right;
        margin-top: 40px;
      }
    }
  }

  .pagination-mobile {
    display: none;
  }
}

@media screen and (max-width: 510px) {
  .banner {
    width: 100%;
    height: 80px;
    font-size: 16px;
    color: #ffffff;
    padding: 0 20px;
    background: url('../../../public/gateway/course/bgImg@2x.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
  }

  .course {
    width: 100%;
    padding: 15px 20px 30px;
    background-color: #f7f7f7;

    .course-b {
      width: 100%;
      margin: 0 auto;

      .title {
        width: 100%;
        font-size: 20px;
        color: #151517;
      }

      .course-list {
        width: 100%;
        margin-top: 10px;
        display: flex;
        align-items: center;

        div {
          width: 145px;
          height: 30px;
          font-size: 10px;
          color: #333333;
          background-color: #ffffff;
          border-radius: 30px;
          border: 1px solid #e3e3e3;
          margin-right: 5px;
          cursor: default;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .course-type-sel {
          color: #ffffff;
          background-color: #0091ff;
        }
      }

      .course-secondary {
        width: 100%;
        height: 35px;
        font-size: 8px;
        color: #333333;
        background-color: #ffffff;
        border-radius: 5px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        cursor: default;

        text-align: center;
        white-space: nowrap;
        overflow-x: scroll;
        overflow-y: hidden;

        div {
          margin: 0 10px;
          white-space: nowrap;
          display: inline-block;
        }

        .course-secondary-sel {
          color: #0091ff;
        }
      }

      ::-webkit-scrollbar {
        display: none;
      }

      .courseList {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        .course-box {
          // width: 160px;
          width: 48%;
          background-color: #ffffff;
          border-radius: 5px;
          margin-top: 20px;

          img {
            // width: 160px;
            width: 100%;
            height: 85px;
            border-radius: 5px 5px 0 0;
            object-fit: cover;
          }

          .box-title {
            width: 100%;
            font-size: 11px;
            font-weight: 600;
            padding: 8px 12px;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            white-space: nowrap;
          }
        }
      }

      .pagination {
        width: 100%;
        text-align: right;
        margin-top: 40px;
      }
    }
  }

  .pagination-pc {
    display: none;
  }
}
</style>
